import type { AddonAppPageState, AddonAppPageStateInput } from '../types';
import { findAddonAppBySlug } from './addonAppMapping';

/**
 * Decides what the addon app page shows. A found app always wins: a failed background refetch
 * keeps the last list cached, and replacing the running frame would discard unsaved work in it.
 */
export function resolveAddonAppPageState({
  addonApps,
  isLoading,
  isError,
  slug,
}: AddonAppPageStateInput): AddonAppPageState {
  const addonApp = findAddonAppBySlug(addonApps ?? [], slug);

  if (addonApp) {
    return { kind: 'frame', addonApp };
  }

  if (isLoading) {
    return { kind: 'loading' };
  }

  if (isError) {
    return { kind: 'load-error' };
  }

  return { kind: 'not-found' };
}
